export function StarIcon({ size = 18, className = '' }: { size?: number; className?: string }) {
  // Use a stable id per-size to avoid DOM duplication warnings across React renders;
  // the gradient is the same for every StarIcon, so a single shared id is fine.
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} className={className}>
      <defs>
        <linearGradient id="pt-me-star-grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#fde047" />
          <stop offset="100%" stopColor="#f59e0b" />
        </linearGradient>
      </defs>
      <polygon
        points="12,2 15,9 22,9.5 16.5,14 18.5,21 12,17 5.5,21 7.5,14 2,9.5 9,9"
        fill="url(#pt-me-star-grad)"
        stroke="#b45309"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function StarRow({ count, size = 18 }: { count: number; size?: number }) {
  return (
    <div className="inline-flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => <StarIcon key={i} size={size} />)}
    </div>
  )
}
